<template>
  <WTooltip :label="tooltipTitle" position="left">
    <WButton
      variant="tertiary"
      icon-button
      size="small"
      :icon="toggleIcon"
      data-cy="close-channels"
      @click="toggleChannels"
    />
  </WTooltip>
</template>
<script>
import { WButton, WTooltip } from '@alice-health/wonderland-vue'
import { mapGetters } from 'vuex'
export default {
  name: 'PDrawerToggle',
  components: { WButton, WTooltip },
  computed: {
    ...mapGetters('ui/channelBar', ['isMenuExpanded']),
    toggleIcon() {
      return this.isMenuExpanded ? 'icArrowCollapse' : 'icArrowExpand1'
    },
    tooltipTitle() {
      return this.isMenuExpanded
        ? 'Mudar para versão compacta'
        : 'Mudar para versão expandida'
    }
  },
  methods: {
    toggleChannels() {
      this.$store.dispatch('ui/channelBar/toggleMenuState')
    }
  }
}
</script>
